import { FaPlus } from "react-icons/fa";
import { FaCaretRight } from "react-icons/fa";

import { useChainId } from "wagmi";

import { PointToken } from "shared/api/use-points-tokens-query";
import Etherscan from "shared/assets/etherscan.svg?react";
import WasabiLogo from "shared/assets/wasabi-logo.svg?react";
import { useResponsive } from "shared/hooks/use-responsive";
import { Button } from "shared/ui/button";
import { Img } from "shared/ui/img";
import { getBlockExplorerLink } from "shared/web3/utils/get-block-explorer-link";

import { RowMobile } from "./row-mobile";

type Props = {
  token: PointToken;
};

export const Row = (props: Props) => {
  const chainId = useChainId();
  const { token } = props;

  const tokenLink = `${getBlockExplorerLink(chainId)}/token/${token.address}`;

  const { md } = useResponsive();

  if (!md) return <RowMobile token={token} />;

  return (
    <div className="bg-baltic-sea/30 grid grid-cols-[3fr_1fr_1fr_0.5fr] items-center rounded-[10px] p-3">
      <div className="flex items-center gap-x-3.5">
        <Img className="size-9" src={token.logoURI} alt={token.symbol} />
        <div className="flex flex-col">
          <div className="leading leading-none capitalize">{token.name}</div>
          <div className="text-nobel/70 mt-1 text-sm leading-[150%] capitalize">
            {token.description}
          </div>
        </div>
      </div>

      <div className="flex items-center gap-1.5">
        {token.multiplier}x
        <div className="bg-spearmint flex size-4.5 items-center justify-center rounded-full p-0.5 text-black">
          <WasabiLogo />
        </div>
      </div>

      <div>
        <Button variant="spearmint/10">
          <FaPlus className="size-3" /> Deposit
        </Button>
      </div>

      <div className="justify-self-end">
        <Button
          as="a"
          target="_blank"
          href={tokenLink}
          variant="nobel/10"
          className="gap-1.5 px-2.5"
        >
          <Etherscan className="size-3" />
          <FaCaretRight className="size-3.5" />
        </Button>
      </div>
    </div>
  );
};
